module.exports = __webpack_public_path__ + "c21ca9d13a17238264b2787240aaee14.svg";